import React from "react";

// reactstrap components
import { Col, Row } from "reactstrap";

// components
import ModuleTitle from "../ModuleTitle";

// animations
import Fade from "react-reveal/Fade";
import Slide from "react-reveal/Slide";

// datas
import { img_markanjo, selfIntroData, selfInsightData } from "./aboutData";

const SelfIntroduction = ({ selfDesc }) => {
  return (
    <Fade right>
      <Row className="ml-0 mr-0 mt-5 mb-5 justify-content-center">
        <Col xl="5" lg="5" className="align-self-center">
          <img
            src={img_markanjo}
            alt="markanjo.png"
            className="mb-4 mb-lg-0 about-image img-fluid"
            loading="lazy"
          />
        </Col>
        <Col xl="6" lg="7" className="align-self-center">
          <div>
            <div className="about-main-desc">
              {selfDesc.map((title, idx) => (
                <span className="d-block" key={idx}>
                  {title};
                </span>
              ))}
            </div>
            <div className="text-left mt-4">
              I am a System Developer in{" "}
              <a
                href="https://xam.com.au/"
                target="_blank"
                rel="noopener noreferrer"
              >
                XAM Consulting.
              </a>{" "}
              <br />
              I also trained in Japan as a System Engineer for 2 years.
              <br />I have a serious passion for coding especially in web
              development.
            </div>
          </div>
        </Col>
      </Row>
    </Fade>
  );
};

const SelfInsight = ({ datas }) => {
  return (
    <Row className="mt-5 border-top">
      {datas.map((data, idx) => {
        return (
          <Col lg="4" className="mt-5" key={idx}>
            <Slide up>
              <div className="insight-content-container">
                <img src={data.imgSrc} width="40%" alt={data.imgAlt} />
                <span className="about-desc-item-title">{data.title}</span>
                {data.desc}
              </div>
            </Slide>
          </Col>
        );
      })}
    </Row>
  );
};

const About = ({ title }) => {
  return (
    <div id="about" className="text-center">
      <div className="about-container m-auto">
        <ModuleTitle title={title} />
        <SelfIntroduction selfDesc={selfIntroData} />
        <SelfInsight datas={selfInsightData} />
      </div>
    </div>
  );
};

export default About;
